import { useClientTranslation } from '@/lib/core/i18n';
import { Button } from '@/components/ui/button';
import { Icon } from '@/components/ui/icon';

interface FollowBrandsBannerProps {
  /** Overrides the default translated title — used when the CMS supplies its own copy. */
  title?: string;
  /** Overrides the default translated description — used when the CMS supplies its own copy. */
  description?: string;
  onClick?: () => void;
}

export function FollowBrandsBanner({ title, description, onClick }: FollowBrandsBannerProps) {
  const t = useClientTranslation();

  return (
    <Button
      type="button"
      variant="tertiary-link"
      palette="dark"
      className="text-jncquoi-neutral-1000 flex h-auto w-full cursor-pointer items-center gap-2.5 bg-jncquoi-neutral-50 p-4 text-left"
      onClick={onClick}
    >
      <div className="flex min-w-0 flex-1 flex-col gap-4">
        <Icon name="bookmark" width={24} height={24} className="shrink-0" />
        <div className="flex flex-col gap-2">
          <span className="font-pp-neue-montreal overflow-hidden text-[14px] leading-none font-semibold tracking-[0.5px] text-ellipsis uppercase">
            {title || t('App.Shop.FollowBrands')}
          </span>
          <span className="font-pp-neue-montreal text-[16px] leading-snug font-normal tracking-[0.25px] wrap-break-word whitespace-normal normal-case">
            {description || t('App.Shop.FollowBrandsDesc')}
          </span>
        </div>
      </div>
      <Icon name="nav-arrow-right" width={16} height={16} className="shrink-0" />
    </Button>
  );
}
